import CustomField from "components/form/CustomField";
import { Form, Formik } from "formik";
import { handleSubmitForm } from "helpers/apiUtils";
import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "store/slices/alertSlice";
import { editProfile, getDetails } from "store/slices/authSlice";
import { editProfileSchema } from "utils/validations";

function EditProfile({ onCancel = () => {}, onSuccess = () => {} }) {
  const { t } = useTranslation();

  const { loading, isLoading, authUserDetails, rolePermissions } = useSelector(
    (state) => state.Auth,
  );
  const dispatch = useDispatch();
  const handleSubmitEditProfile = (values) => {
    const payload = {
      name: values.name,
      phoneNumber: values.phoneNumber,
    };
    handleSubmitForm({
      dispatch,
      action: editProfile,
      payload,
      onSuccess: () => {
        onSuccess();
        dispatch(getDetails());
        dispatch(
          showAlert({
            text: t(`Profile updated successfully`),
            type: "success",
          }),
        );
      },
    });
  };
  const [initialValues, setInitialValues] = useState({
    name: "",
    phoneNumber: "",
  });
  useEffect(() => {
    if (authUserDetails) {
      const { name, phoneNumber } = authUserDetails || {};
      setInitialValues({
        name,
        phoneNumber,
      });
    }
  }, [authUserDetails]);
  return (
    <div className="edit_profile_modal">
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={editProfileSchema(t)}
        onSubmit={handleSubmitEditProfile}
      >
        {() => (
          <Form>
            <Col lg={12}>
              <div className="form_field">
                <CustomField
                  label={t("Name")}
                  name="name"
                  placeholder={t("Enter name")}
                  required
                />
              </div>
            </Col>

            <Col lg={12}>
              <div className="form_field">
                <CustomField
                  label={t("Phone Number")}
                  name="phoneNumber"
                  placeholder="+9665XXXXXXXX"
                  required
                />
              </div>
            </Col>

            <button
              type="submit"
              className="main_btn w-100 mt-3"
              disabled={isLoading}
            >
              {isLoading ? t("Submitting...") : t("Submit")}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default EditProfile;
